import React, { forwardRef, useSyncExternalStore } from 'react'
import { LuSearch } from 'react-icons/lu'
import { optionDomId } from './dropdownSearch'

const DropdownSearchField = forwardRef(({ highlight, activeOf, listId, ...inputProps }, ref) => {
  const activeKey = useSyncExternalStore(highlight.subscribe, () => activeOf(highlight.get()))
  return (
    <label className="relative block p-2 border-b border-divider">
      <LuSearch size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary pointer-events-none" />
      <input
        ref={ref}
        type="text"
        role="combobox"
        aria-label="Search"
        aria-expanded="true"
        aria-autocomplete="list"
        aria-controls={listId}
        aria-activedescendant={optionDomId(listId, activeKey)}
        placeholder="Search"
        autoComplete="off"
        autoFocus
        className="w-full h-9 pl-8 pr-3 rounded-md border border-divider bg-transparent text-lg text-text-primary placeholder:text-text-secondary focus:outline-none focus:border-primary-main"
        {...inputProps}
      />
    </label>
  )
})

export default DropdownSearchField
